/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdTokens, FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdTokensFromJSONTyped, FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdTokensToJSON, } from './FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdTokens';
export function FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdResponseTokensFromJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdResponseTokensFromJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdResponseTokensFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdTokens(json)) {
        return FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdTokensFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdResponseTokensToJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdResponseTokensToJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdResponseTokensToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdTokens(value)) {
        return FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdTokensToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdResponseTokens.js.map